import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency.tsx';
import { SbSharedRefineMenuPriceRanges } from '../../SbSharedRefineMenu/SbSharedRefineMenuPriceRanges/SbSharedRefineMenuPriceRanges.jsx';
import { SbSharedRefineMenuSaleInput } from '../../SbSharedRefineMenu/SbSharedRefineMenuSaleInput/SbSharedRefineMenuSaleInput.tsx';
import { SbSharedRefineMenuNetPriceTradeDiscount } from '../../SbSharedRefineMenu/SbSharedRefineMenuNetPriceTradeDiscount/SbSharedRefineMenuNetPriceTradeDiscount.tsx';

import { type RefineMenuFilter } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilters.tsx';

import { type SbRespRefineMenuFilterPrice_user$key } from './__generated__/SbRespRefineMenuFilterPrice_user.graphql.ts';
import { type SbRespRefineMenuFilterPrice_itemSearch$key } from './__generated__/SbRespRefineMenuFilterPrice_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbRespRefineMenuFilterPrice_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuInputRangeCurrency_itemSearch
        ...SbSharedRefineMenuPriceRanges_itemSearch
        ...SbSharedRefineMenuSaleInput_itemSearch
        ...SbSharedRefineMenuNetPriceTradeDiscount_itemSearch
    }
`;

const userFragment = graphql`
    fragment SbRespRefineMenuFilterPrice_user on User {
        ...SbSharedRefineMenuPriceRanges_user
    }
`;
type Props = {
    currency: string;
    user: SbRespRefineMenuFilterPrice_user$key;
    itemSearch: SbRespRefineMenuFilterPrice_itemSearch$key;
    filterName: string;
    filter: RefineMenuFilter;
    trackingOptions?: Record<string, unknown>;
};

export const SbRespRefineMenuFilterPrice: FC<Props> = props => {
    const { user: userRef, itemSearch: itemSearchRef, trackingOptions } = props;

    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const user = useFragment(userFragment, userRef);

    return (
        <>
            <SbSharedRefineMenuPriceRanges
                {...props}
                user={user}
                itemSearch={itemSearch}
                trackingOptions={trackingOptions}
            />
            <SbSharedRefineMenuInputRangeCurrency
                {...props}
                itemSearch={itemSearch}
                showInvalidRangeErrorMessage={false}
                trackingOptions={trackingOptions}
            />

            <SbSharedRefineMenuNetPriceTradeDiscount
                itemSearch={itemSearch}
                trackingOptions={trackingOptions}
            />
            <SbSharedRefineMenuSaleInput
                {...props}
                itemSearch={itemSearch}
                trackingOptions={trackingOptions}
            />
        </>
    );
};
